(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-block"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    window.pscrollbars = [];
    $('.image-block-size-2').each(function(index) {
      var ps = new PerfectScrollbar($(this)[0], {
        wheelSpeed: 2,
        wheelPropagation: true,
        minScrollbarLength: 20,
        suppressScrollY: true
      });
      window.pscrollbars.push(ps);
    });

    $(window).on("debouncedresize", function( event ) {
      for(var i = 0; i < window.pscrollbars.length; i++) {
        window.pscrollbars[i].update();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-product-block"] && !window.DesignMode) return;
  try {
    
  $(function(){
    $('.section-product-blocks').on('click', '.custom-radio > a', function(e){
      e.preventDefault();
      var handle = $(this).data('handle');
      var $productBlock = $(this).parents('.product-block');
      var $productColors = $(this).parents('.product-colors');
      var $productColorway = $('.product-colorway-collection', $productBlock);

      $('li a.active', $productColors).removeClass('active');
      $('li.active', $productColorway).removeClass('active');

      $('[data-handle="' + handle + '"]', $productColors).addClass('active');
      $('[data-handle="' + handle + '"]', $productColorway).addClass('active');
    });
    $('.section-product-blocks').on('mouseenter', '.product-colors-count', function(e){
      if(!MylesShared.isMobileView) {
        var $colorway = $(this).siblings('.product-colors');
        $(this).addClass('invisible');
        $colorway.removeClass('hidden');
      }
    });
    $('.section-product-blocks').on('mouseleave', '.product-colors', function(e){
      if(!MylesShared.isMobileView) {
        var $colorcount = $(this).siblings('.product-colors-count');
        $(this).addClass('hidden');
        $colorcount.removeClass('invisible');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
